function initEvPartCards(scope) {
  scope.querySelectorAll('form.ev-product-form').forEach(form => {
    if (form.dataset.evReady) return;
    form.dataset.evReady = 'true';
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('.ev-product-add');
      if (button.disabled) return;
      const label = button.querySelector('[data-button-label]');
      const feedback = form.querySelector('.ev-product-feedback');
      const text = feedback.querySelector('[data-feedback-text]');
      const viewCart = feedback.querySelector('[data-view-cart]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = button.dataset.addingLabel;
      text.textContent = '';
      viewCart.hidden = true;
      feedback.classList.remove('is-error');
      try {
        const response = await fetch(form.action + '.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:form.querySelector('[name="id"]').value,quantity:1})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || feedback.dataset.error);
        label.textContent = button.dataset.addedLabel;
        button.classList.add('is-added');
        text.textContent = feedback.dataset.success;
        viewCart.hidden = false;
        try {
          const cartResponse = await fetch(viewCart.href + '.js', {headers:{'Accept':'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-sh] .sh-actions a').forEach(link => {
              if (link.getAttribute('href') !== new URL(viewCart.href).pathname) return;
              link.setAttribute('aria-label', feedback.dataset.cartLabel + ', ' + cart.item_count);
              let badge = link.querySelector('.sh-cart-count');
              if (!badge) {badge = document.createElement('span');badge.className = 'sh-cart-count';link.append(badge);}
              badge.textContent = cart.item_count;
            });
          }
        } catch {}
      } catch (error) {
        feedback.classList.add('is-error');
        text.textContent = error.message || feedback.dataset.error;
      } finally {
        button.removeAttribute('aria-busy');
        setTimeout(() => {button.disabled = false;button.classList.remove('is-added');label.textContent = button.dataset.addLabel;}, 1600);
      }
    });
  });
}
initEvPartCards(document);
document.addEventListener('shopify:section:load', event => initEvPartCards(event.target));
document.addEventListener('ev:cards:loaded', event => initEvPartCards(event.target));


let evCardInitQueued = false;
new MutationObserver(mutations => {
  if (evCardInitQueued) return;
  const addedCards = mutations.some(mutation => [...mutation.addedNodes].some(node => node.nodeType === 1 && (node.matches('.ev-product, .ev-product-form, product-card') || node.querySelector('.ev-product-form'))));
  if (!addedCards) return;
  evCardInitQueued = true;
  queueMicrotask(() => {evCardInitQueued = false;initEvPartCards(document);});
}).observe(document.body, {childList:true,subtree:true});
